import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import "./navbar.css";
import NavContext from '../../contexts/NavContext';

// Icons
import Logo from '../../assets/images/logo.svg';
import Dashboard from '../../assets/icons/dashboard.svg';
import Home from '../../assets/icons/home.svg';
import Basket from '../../assets/icons/basket.svg';
import Shop from '../../assets/icons/shop.svg';
import Building from '../../assets/icons/building.svg';
import info from '../../assets/icons/info.svg';
import Phone from '../../assets/icons/phone.svg';
import Book from '../../assets/icons/book.svg';
import User from '../../assets/icons/user.svg';
import Logout from '../../assets/icons/logout.svg';

const NavbarComponent = () => {
  const [collapsed, setCollapsed] = useState(true);
  const { setNav } = useContext(NavContext);

  // دریافت مسیر فعلی
  const location = useLocation();
  const currentPath = location.pathname;

  // تعیین کلاس active بر اساس مسیر فعلی
  const isActive = (path) => (currentPath === path ? 'active menu-item' : 'menu-item');


  const logout = () => {
    localStorage.removeItem("userInfo");
    window.location.href = '/'
  }
  return (
    <>
      <Sidebar rtl={true} collapsed={collapsed}>
        <Menu>
          <MenuItem onClick={() => setCollapsed(!collapsed)}>
            <div className="d-flex align-items-center gap-3">
              <img src={Dashboard} alt="Dashboard Icon" className="icon mr-2" />
              <img src={Logo} alt="Logo" className="logo" />
            </div>
          </MenuItem>

          <MenuItem className={isActive('/home')}>
            <Link to="/home" className="d-flex align-items-center">
              <img src={Home} alt="Home Icon" className="icon me-2" />
              صفحه اصلی
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/products')}>
            <Link to="/products" className="d-flex align-items-center">
              <img src={Basket} alt="Products Icon" className="icon me-2" />
              محصولات
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/shops')} >
            <Link to="/shops" className="d-flex align-items-center">
              <img src={Shop} alt="Shop Icon" className="icon me-2" />
              فروشگاه
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/branchs')} >
            <Link to="/branchs" className="d-flex align-items-center">
              <img src={Building} alt="Branchs Icon" className="icon me-2" />
              شعبه‌ها
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/about-us')} >
            <Link to="/about-us" className="d-flex align-items-center">
              <img src={info} alt="About Icon" className="icon me-2" />
              درباره ما
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/contact-us')} >
            <Link to="/contact-us" className="d-flex align-items-center">
              <img src={Phone} alt="Contact Icon" className="icon me-2" />
              امور مشتریان
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/blogs')}>
            <Link to="/blogs" className="d-flex align-items-center">
              <img src={Book} alt="Blogs Icon" className="icon me-2" />
              اخبار و وبلاگ‌ها
            </Link>
          </MenuItem>

          <MenuItem className={isActive('/employment')}>
            <Link to="/employment" className="d-flex align-items-center">
              <img src={User} alt="Backoffice Icon" className="icon me-2" />
              استخدام و همکاری
            </Link>
          </MenuItem>

          <MenuItem onClick={logout}>
            <div className="d-flex align-items-center">
              <img src={Logout} alt="Logout Icon" className="icon me-2" />
              خروج
            </div>
          </MenuItem>
        </Menu>
      </Sidebar>
    </>
  );
};

export default NavbarComponent;
